import React, { Fragment, useState, useEffect } from 'react'
import callApi from '../../helpers/callapi'
import { Form, Card, Button, Row, Col, Table, Badge, Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { orderBy } from 'lodash'
import moment from 'moment'
import CONSTANTS, { fullMonthTH } from '../../constants/constants'
import OrderItemsDataTable from '../Order/OrderItemsDataTable'
import { getRounds } from '../../services/config-services'

export default function Gifts() {
  const [roundDate, setRoundDate] = useState()
  const [rounds, setRounds] = useState([])
  const [userId, setUserId] = useState('')
  const [searchUserId, setSearchUserId] = useState('')
  const [users, setUsers] = useState([])
  const [type, setType] = useState('sent')
  const [showViewOrder, setShowViewOrder] = useState(false)
  const [order, setOrder] = useState({})
  const dispatch = useDispatch()

  const fetchAllRounds = async () => {
    const data = await getRounds()
    setRoundDate(data[0].value)
    setRounds(data.map((r) => ({ roundDate: r.value })))
  }

  const fetchUsers = async (_query = {}) => {
    try {
      dispatch({ type: 'loading_show' })
      const query = {
        ..._query,

        type: type,
        roundDate: roundDate,
      }
      const response = await callApi({
        url: `/users/${userId}/gifts`,
        query,
      })
      //console.log(response)
      setUsers(response)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      setUsers([])
      dispatch({ type: 'loading_hide' })
    }
  }

  async function fetchOrderDetail(orderId) {
    return await callApi({ url: `/orders/${orderId}` })
  }
  function handleOrderSelected(orderId) {
    fetchOrderDetail(orderId)
      .then((response) => {
        setOrder(response)
      })
      .catch((err) => console.log(err.reason))
  }

  useEffect(() => {
    fetchUsers()
    fetchAllRounds()
  }, [])

  //console.log(order);

  const onChange = (e) => {
    e.preventDefault()
    setSearchUserId(userId)
    fetchUsers(1, e.target.value)
  }
  const BANK = CONSTANTS.banks
  const bank = Object.keys(BANK).map((key) => (order.user?.ownerBankName === key ? BANK[key] : null))
  const bankName = bank.filter((s) => s !== null)

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Gifts</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form>
            <Form.Group>
              <Row>
                <Col sm={12} md={6} lg={3}>
                  <select
                    className="form-control"
                    style={{ color: '#5d5d5d' }}
                    onChange={async (value) => {
                      setRoundDate(value.target.value)
                    }}
                  >
                    {rounds &&
                      rounds.map((round, i) => {
                        return (
                          <option key={i} value={round.roundDate}>
                            {round.roundDate}
                          </option>
                        )
                      })}
                  </select>
                </Col>
                <Col sm={12} md={6} lg={3}>
                  <select
                    className="form-control"
                    style={{ color: '#5d5d5d' }}
                    onChange={(value) => {
                      setType(value.target.value)
                    }}
                  >
                    {/* <option value="select">Select...</option> */}
                    <option value="sent">รหัสสมาชิกผู้ส่ง</option>
                    <option value="received">รหัสสมาชิกผู้รับ</option>
                  </select>
                </Col>
                <Col sm={12} md={6} lg={3}>
                  <input
                    className="form-control"
                    style={{ color: '#5d5d5d' }}
                    type="text"
                    placeholder="รหัสสมาชิก"
                    onChange={(e) => setUserId(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        //console.log("ononononon");
                        onChange(e)
                      }
                    }}
                    defaultValue={userId}
                  />
                </Col>
                <Col sm={12} md={6} lg={3}>
                  <Button variant="primary light" className="w-50" onClick={(e) => onChange(e)}>
                    ค้นหา
                  </Button>
                </Col>
              </Row>
            </Form.Group>
          </Form>

          {
            users && users.status === 'success' && (
              <div style={{ marginTop: '30px' }}>
                {type === 'sent' ? (
                  <div>
                    <h4>รายการ Order ผู้รับ</h4>
                    <Table responsive striped bordered className="verticle-middle">
                      <thead>
                        <tr>
                          <th>หมายเลขคำสั่งซื้อ</th>
                          <th>ชื่อผู้รับ</th>
                          <th>รหัสสมาชิก</th>
                          <th>วันที่ซื้อ</th>
                          {/* <th>วันที่รับของขวัญ</th> */}
                          <th>รายละเอียดคำสั่งซื้อ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users &&
                          users.result.map((value, i) => {
                            return (
                              <tr key={i}>
                                <td>{value.refNo}</td>
                                <td>
                                  {value.userFirstName} {value.userLastName}
                                </td>
                                <td>{value.userId}</td>
                                <td>
                                  {value.createdAt
                                    ? new Date(value.createdAt).toLocaleString('TH-th')
                                    : value.createdAt}
                                </td>
                                {/* <td>
                        {value.receivedAt
                            ? new Date(value.receivedAt).toLocaleString("TH-th")
                            : value.receivedAt}
                        </td> */}
                                <td>
                                  <Badge
                                    variant="primary light"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      handleOrderSelected(value.id)
                                      setShowViewOrder(true)
                                    }}
                                  >
                                    ดูคำสั่งซื้อ
                                  </Badge>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div>
                    <h4>รายการ Order ผู้ส่ง</h4>
                    <Table responsive striped bordered className="verticle-middle">
                      <thead>
                        <tr>
                          <th>หมายเลขคำสั่งซื้อ</th>
                          <th>ชื่อผู้ส่ง</th>
                          <th>วันที่ซื้อ</th>
                          {/* <th>วันที่รับของขวัญ</th> */}
                          <th>รายละเอียดคำสั่งซื้อ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users &&
                          users.result.map((value, i) => {
                            return (
                              <tr key={i}>
                                <td>{value.refNo}</td>
                                <td>{value.senderName}</td>
                                <td>
                                  {value.createdAt
                                    ? new Date(value.createdAt).toLocaleString('TH-th')
                                    : value.createdAt}
                                </td>
                                {/* <td>
                        {value.receivedAt
                            ? new Date(value.receivedAt).toLocaleString("TH-th")
                            : value.receivedAt}
                        </td> */}
                                <td>
                                  <Badge
                                    variant="primary light"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      handleOrderSelected(value.id)
                                      setShowViewOrder(true)
                                    }}
                                  >
                                    ดูคำสั่งซื้อ
                                  </Badge>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>
            )
            // : (
            //   <div style={{ marginTop: "30px" }}>
            //     <h4>รายการ Order ผู้ส่ง</h4>
            //     <Table responsive striped bordered className="verticle-middle">
            //       <thead>
            //         <tr>
            //           <th>หมายเลขคำสั่งซื้อ</th>
            //           <th>ชื่อผู้ส่ง</th>
            //           <th>วันที่ซื้อ</th>
            //           {/* <th>วันที่รับของขวัญ</th> */}
            //           <th>รายละเอียดคำสั่งซื้อ</th>
            //         </tr>
            //       </thead>
            //       <tbody>
            //         {users && users.result.map((value, i) => {
            //           return (
            //             <tr key={i}>
            //               <td>{value.refNo}</td>
            //               <td>
            //                 {value.senderName}
            //               </td>
            //               <td>
            //                 {value.createdAt
            //                   ? new Date(value.createdAt).toLocaleString("TH-th")
            //                   : value.createdAt}
            //               </td>
            //               {/* <td>
            //               {value.receivedAt
            //                   ? new Date(value.receivedAt).toLocaleString("TH-th")
            //                   : value.receivedAt}
            //               </td> */}
            //               <td>
            //                 <Badge
            //                   variant="primary light"
            //                   style={{ cursor: "pointer" }}
            //                   onClick={() => {
            //                     handleOrderSelected(value.id);
            //                     setShowViewOrder(true);
            //                   }}
            //                 >
            //                   ดูคำสั่งซื้อ
            //                 </Badge>
            //               </td>
            //             </tr>
            //           );
            //         })}
            //       </tbody>
            //     </Table>
            //   </div>
            //)
          }

          <Modal show={showViewOrder} size="lg">
            <Modal.Header>
              <Modal.Title>คำสั่งซื้อ #{order.refNo}</Modal.Title>
              <Button variant="" className="close" onClick={() => setShowViewOrder(false)}>
                <span>&times;</span>
              </Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <div className="border-bottom mb-2">
                    <h4>ข้อมูลลูกค้า</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex">
                    <ul className="w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>{`${order.userFirstName} ${order.userLastName}`}</div>
                          <div>{order.userId}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>{order.userPhone || ''}</div>
                          <div>{order.user?.name}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>เบอร์บัญชีที่เงินเข้า</div>
                          <div>-</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>เบอร์บัญชีลูกค้า</div>
                          <div>{`ธ. ${bankName} ${order.user?.ownerBankNo}`}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h4>ข้อมูลการสั่งซื้อ</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex">
                    <ul className="w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>วันที่ซื้อ</div>
                          <div>
                            {order.createdAt ? new Date(order.createdAt).toLocaleString('TH-th') : order.createdAt}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>วันที่ส่งหลักฐาน</div>
                          <div>
                            {order.submitPaymentAt !== null
                              ? new Date(order.submitPaymentAt).toLocaleString('TH-th')
                              : '-'}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>วันที่ยืนยันคำสั่งซื้อ</div>
                          <div>
                            {order.approvedAt !== null ? new Date(order.approvedAt).toLocaleString('TH-th') : '-'}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>วันที่รับของขวัญ</div>
                          <div>
                            {order.receivedAt !== null ? new Date(order.receivedAt).toLocaleString('TH-th') : '-'}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-3 mb-2">
                    <h4>รายการตรวจสอบ</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex w-100">
                    <ul className="d-flex flex-column w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>สถานะ : </div>
                          <div style={{ fontSize: '14px' }}>
                            <span className="text-success">
                              ซื้อสำเร็จ{' '}
                              {order.approver && order.approver.username && (
                                <span className="text-info">โดย {order.approver.username}</span>
                              )}
                            </span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <li>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '8px' }}>
                      <div>ยอดรวม</div>
                      <h3 style={{ color: 'red' }}>{`${order.totalPrice} บาท`}</h3>
                    </div>
                  </li>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h3>หลักฐานการโอนเงิน</h3>
                  </div>
                </Col>
              </Row>
              <Row>
                {order.evidence ? (
                  <Col>
                    <div
                      style={{
                        justifyContent: 'center',
                        display: 'flex',
                      }}
                    >
                      <img
                        src={`${order.evidence}`}
                        style={{
                          maxWidth: '360px',
                          maxHeight: '600px',
                        }}
                        alt="slip"
                      />
                    </div>
                  </Col>
                ) : (
                  <Col>
                    <div
                      style={{
                        marginBottom: '8px',
                        textAlign: 'center',
                        color: 'red',
                      }}
                    >
                      ไม่พบสลิปสำหรับคำสั่งซื้อ #{order.refNo}
                    </div>
                  </Col>
                )}
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h3>
                      รายละเอียดการสั่งซื้อ{' '}
                      <span style={{ fontSize: '20px' }} className="text-info">
                        ({order.isBox ? 'กล่องสุ่ม' : 'ลอตเตอรี่'})
                      </span>
                    </h3>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <OrderItemsDataTable items={order.items} />
                </Col>
              </Row>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button
                variant="danger light"
                onClick={() => setShowViewOrder(false)}
              >
                ยกเลิก
              </Button>
            </Modal.Footer> */}
          </Modal>
        </Card.Body>
      </Card>
    </Fragment>
  )
}
